// R-162 — QC-step batch transition confirm modal. Operator must explicitly
// continue or stop when crossing batches in a QC step (qa/supervisor).

interface Props {
  open: boolean;
  fromBatch: string | null;
  toBatch: string | null;
  onContinue: () => void;
  onStop: () => void;
}

export function CrossBatchConfirmModal({ open, fromBatch, toBatch, onContinue, onStop }: Props) {
  if (!open) return null;
  return (
    <div className="cross-batch-modal__backdrop">
      <div
        className="cross-batch-modal__card"
        role="dialog"
        aria-labelledby="cross-batch-title"
      >
        <h2 id="cross-batch-title" className="cross-batch-modal__title">
          {fromBatch ? `Finished Batch ${fromBatch}.` : "Finished current batch."}
        </h2>
        <p className="cross-batch-modal__body">
          {toBatch ? `Continue with Batch ${toBatch}?` : "Continue with the next batch?"}
        </p>
        <div className="cross-batch-modal__actions">
          <button type="button" className="cross-batch-modal__btn-secondary" onClick={onStop}>
            Stop here
          </button>
          <button type="button" className="cross-batch-modal__btn-primary" onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
